import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EsItemList from '../../components/es/EsItemList';
import { reqEsItemListAction, resetItemStatus, reqEsItemListDoneAction, reqEsItemListDoneAddAction } from '../../modules/es/esItemModule';
import styled from 'styled-components';
import CheckBtn from '../../components/common/button/CheckBtn';
import {isMobileOnly} from 'react-device-detect';
import { groupBy, forEach, remove, concat, findIndex, replace } from 'lodash';
import { useHistory } from 'react-router-dom';

const EstimateDoneListHeaderBlock = styled.div`
    ${isMobileOnly?`
    //margin: 0 4vw; 
    background: #ffffff; 
    margin-bottom: 20px;
    height: 6px;
    `:`
    height: 20px;
    padding: 17px 0px;
    `};
    
`;

const EstimateDoneListHeaderCheckBlock = styled.div`
    ${isMobileOnly?`
    margin-left: 4vw; 
    `:`
    
    `};
    float : left;
    margin-top: -4px;
`;
const EstimateDoneListHeaderSpanBlock = styled.span`
    ${isMobileOnly?`
    font-size: 14px;
    line-height: 26px;   
    `:`
    font-size: 16px;
    `};
    float : left;
    margin-left : 10px;
    
    font-weight: normal;
    text-align: left;
    color: #333333;
`;

const EstimateListDoneMoreBlock = styled.p`
    text-align: center;
`;

const EstimateListDoneMoreBtnBlock = styled.button`
    ${isMobileOnly?`
    margin-bottom: 40px;
    `:`
    margin-top: 40px;
    `};

    text-align: center;
    color: #111;
    font-size: 14px;
    text-decoration: underline;
    
`;

const EsItemsDoneListContainer = ({ curIdx}) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const { esListDoneResult, esItemsDone, error, loading, accessToken, esItemCheck, esItemsDoneCount } = useSelector(
        ({ esItemsReducer, loadingReducer, userReducer }) => ({
            esListDoneResult: esItemsReducer.esListDoneResult,
            esItemsDone: esItemsReducer.esItemsDone,
            error: esItemsReducer.error,
            loading: loadingReducer['esitem/LIST_ES_DONE'],
            accessToken: userReducer.accessToken,
            esItemCheck: esItemsReducer.esItemCheck,
            esItemsDoneCount: esItemsReducer.esItemsDoneCount,
        })
    );

    useEffect(() => {
        if (accessToken !== null) {
            //dispatch(reqEsItemListAction("type=0&sort=0"));
            //console.log("history = " + JSON.stringify(history))
            if(history.action !== 'POP' || esItemsDone === null){
                dispatch(reqEsItemListDoneAction());
            } 
        }

    }, []);

    useEffect(() => {
        if (accessToken !== null && esListDoneResult === null) {
            //dispatch(reqEsItemListAction("type=0&sort=0"));
            dispatch(reqEsItemListDoneAction());
        } else if (esListDoneResult === 600) {
            dispatch(resetItemStatus());
        }

    }, [accessToken, esListDoneResult]);

    // 체크 상태 확인
    const getCheckStatus = () => {
        let ret = true;

        if(esItemsDone === null || esItemsDone === undefined || esItemsDone.length < 1) {
            return false;
        }

        forEach(esItemsDone, (curobjs, index) => {
            let curobj = curobjs[0];
            if(curobj.rqst_status==="050105"){
                
                let idx = findIndex(esItemCheck, (curitem) => {
                    return (curitem.es_rqst_id === curobj.es_rqst_id);
                })
                //console.log("esItemCheck = " + JSON.stringify(esItemCheck))
                if (idx < 0) {
                    ret = false;
                }
            }

        });

        return ret;
    }

    const isMoreBtnShow = () => {
        //return true;
        //console.log("esItemsDone = " + JSON.stringify(esItemsDone))
        if (esItemsDone === null ||
            esItemsDoneCount === 0 ||
            esItemsDoneCount <= esItemsDone.length) {
            return false;
        }

        return true;
    }

    const handlerMoerClick = () => {
        let count = esItemsDone.length*1;
        //console.log('count = ' + count);
        dispatch(reqEsItemListDoneAddAction(count.toString()));
    }

    if(esItemsDone === null || esItemsDone === undefined || loading) {
        return <div></div>;
    } 
    
    const getHiddenHeader = () => {
        if(esItemsDone === null || esItemsDone === undefined || esItemsDone.length < 1) {
            return true;
        }

        return false;
    }

    return (
    <div>
        <EstimateDoneListHeaderBlock  >
                
        </EstimateDoneListHeaderBlock>
        <EsItemList
        loading={loading}
        accessToken={accessToken}
        esItems={esItemsDone}
        curIdx={curIdx}
        
        />

        {isMoreBtnShow() ?
            <EstimateListDoneMoreBlock>
                <EstimateListDoneMoreBtnBlock onClick={handlerMoerClick}>더보기
            </EstimateListDoneMoreBtnBlock>
            </EstimateListDoneMoreBlock> : ''
        }
    </div>
        

    )

}

export default EsItemsDoneListContainer;